(() => {
  const trackerVersion = '2.4.0';
  const courseIdsByHandle = {
    'fusion-der-ultimative-einsteiger-video-kurs': '8609643266313',
    'fusion-360-mesh-bearbeitung-3d-scan-und-stl-digitaler-video-kurs': '9401608700169',
    '3d-druck-verstehen-und-beherrschen': '15574336831753',
  };
  const configElement = document.getElementById('mm-conversion-config');
  if (!configElement || window.Shopify?.designMode) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent || '{}');
  } catch (error) {
    return;
  }
  const isHomepage = config.page_type === 'index';
  if (!config.product?.id && !isHomepage) return;

  const pendingEvents = [];
  const seenSections = new Set();
  const activeSections = new Map();
  let initialized = false;
  let lastCtaAt = 0;
  let vitalsPublished = false;
  const vitals = { cls: 0, inp: 0, lcp: 0 };

  const compactText = (value, maxLength = 255) => (value || '').replace(/\s+/g, ' ').trim().slice(0, maxLength);

  const productHandleFromUrl = (value) => {
    try {
      const path = new URL(value || '', window.location.origin).pathname;
      return compactText(path.split('/products/')[1]?.split('/')[0] || '', 255);
    } catch (error) {
      return '';
    }
  };

  const trackedSections = () => {
    const main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return [];
    return Array.from(main.children).filter((element) => element.id?.startsWith('shopify-section-'));
  };

  const sectionDetails = (element) => {
    const section = element?.closest?.('[id^="shopify-section-"]') || element;
    if (!section?.id) return {};
    const allSections = trackedSections();
    const rawId = section.id.replace(/^shopify-section-/, '');
    const stableId = rawId.includes('__') ? rawId.split('__').slice(1).join('__') : rawId;
    const heading = section.querySelector('h1, h2, h3, [data-mm-analytics-name]');
    return {
      section_id: stableId.slice(0, 255),
      section_name: compactText(heading?.dataset?.mmAnalyticsName || heading?.textContent || stableId),
      section_index: Math.max(0, allSections.indexOf(section)),
    };
  };

  const attribution = () => {
    const params = new URLSearchParams(window.location.search);
    const current = {
      source: compactText(params.get('utm_source') || '', 255),
      medium: compactText(params.get('utm_medium') || '', 255),
      campaign: compactText(params.get('utm_campaign') || '', 255),
      content: compactText(params.get('utm_content') || '', 255),
      term: compactText(params.get('utm_term') || '', 255),
      gclid: compactText(params.get('gclid') || '', 255),
      gbraid: compactText(params.get('gbraid') || '', 255),
      wbraid: compactText(params.get('wbraid') || '', 255),
    };
    let stored = {};
    try {
      stored = JSON.parse(window.sessionStorage.getItem('mm_attribution_v1') || '{}');
      if (Object.values(current).some(Boolean)) {
        stored = { ...stored, ...Object.fromEntries(Object.entries(current).filter(([, value]) => value)) };
        window.sessionStorage.setItem('mm_attribution_v1', JSON.stringify(stored));
      }
    } catch (error) {}
    const result = { ...stored, ...Object.fromEntries(Object.entries(current).filter(([, value]) => value)) };
    if (!result.source && (result.gclid || result.gbraid || result.wbraid)) result.source = 'google';
    if (!result.medium && (result.gclid || result.gbraid || result.wbraid)) result.medium = 'cpc';
    return result;
  };

  const baseEvent = () => {
    const campaign = attribution();
    let referrer = '';
    try {
      referrer = document.referrer ? `${new URL(document.referrer).origin}${new URL(document.referrer).pathname}` : '';
    } catch (error) {}
    return {
      page_path: window.location.pathname.slice(0, 1024),
      page_url: window.location.href.slice(0, 4096),
      page_title: compactText(document.title, 512),
      product_id: String(config.product?.id || '').slice(0, 96),
      product_handle: compactText(config.product?.handle, 255),
      product_title: compactText(config.product?.title, 512),
      source: campaign.source || compactText(referrer ? new URL(referrer).hostname : 'Direkt', 255),
      medium: campaign.medium || '',
      campaign: campaign.campaign || '',
      referrer: referrer.slice(0, 4096),
      device_type: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
      theme_id: String(config.theme?.id || window.Shopify?.theme?.id || '').slice(0, 96),
      theme_name: compactText(config.theme?.name || window.Shopify?.theme?.name, 255),
      theme_role: compactText(config.theme?.role || window.Shopify?.theme?.role, 32),
      experience_version: compactText(config.experience_version || `theme-${config.theme?.id || 'unknown'}`, 96),
      occurred_at: new Date().toISOString(),
    };
  };

  const publishPending = () => {
    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return false;
    while (pendingEvents.length) {
      const event = pendingEvents.shift();
      publish('mistermestro:conversion', event);
    }
    return true;
  };

  const track = (eventName, details = {}) => {
    const acquisition = attribution();
    const metadata = {
      schema_version: 2,
      tracker_version: trackerVersion,
      debug: new URLSearchParams(window.location.search).has('webPixelDebug'),
      utm_content: acquisition.content || '',
      utm_term: acquisition.term || '',
      gclid: acquisition.gclid || '',
      gbraid: acquisition.gbraid || '',
      wbraid: acquisition.wbraid || '',
      ...(details.metadata_json || {}),
    };
    pendingEvents.push({ ...baseEvent(), ...details, metadata_json: metadata, event_name: eventName });
    publishPending();
  };

  const observePerformance = () => {
    if (typeof PerformanceObserver !== 'function') return;
    try {
      new PerformanceObserver((list) => {
        const entries = list.getEntries();
        if (entries.length) vitals.lcp = Math.round(entries[entries.length - 1].startTime);
      }).observe({ type: 'largest-contentful-paint', buffered: true });
    } catch (error) {}
    try {
      new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          if (!entry.hadRecentInput) vitals.cls += entry.value;
        });
      }).observe({ type: 'layout-shift', buffered: true });
    } catch (error) {}
    try {
      new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          if (entry.interactionId) vitals.inp = Math.max(vitals.inp, Math.round(entry.duration));
        });
      }).observe({ type: 'event', buffered: true, durationThreshold: 40 });
    } catch (error) {}
  };

  const publishVitals = () => {
    if (vitalsPublished) return;
    vitalsPublished = true;
    Object.entries(vitals).forEach(([metric, value]) => {
      if (value > 0) track('web_vital', { metadata_json: { metric, value } });
    });
  };

  const trackCta = (target) => {
    const now = Date.now();
    if (now - lastCtaAt < 400) return;
    lastCtaAt = now;
    const section = sectionDetails(target);
    const href = target?.getAttribute?.('href') || target?.getAttribute?.('action') || target?.closest?.('form')?.action || '';
    const destinationHandle = target?.dataset?.mmHomeCourse || productHandleFromUrl(href);
    const placement = target?.dataset?.mmPlacement || section.section_id || 'unbekannt';
    const normalizedHref = compactText(href.split('?')[0], 1024);
    const isCheckout = normalizedHref.includes('/checkout');
    const isProduct = Boolean(destinationHandle);
    track('cta_click', {
      ...section,
      metadata_json: {
        label: compactText(target?.textContent || target?.value, 160),
        destination_product_handle: compactText(destinationHandle, 255),
        destination_product_id: courseIdsByHandle[destinationHandle] || '',
        destination_path: normalizedHref,
        placement: compactText(placement, 120),
        cta_position: compactText(placement, 120),
        cta_type: isCheckout ? 'checkout' : (isProduct ? 'course_navigation' : 'action'),
        element_type: compactText(target?.tagName?.toLowerCase(), 40),
      },
    });
  };

  const observeSections = () => {
    const sections = trackedSections();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const details = sectionDetails(entry.target);
        if (!details.section_id) return;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.15) {
          if (!seenSections.has(details.section_id)) {
            seenSections.add(details.section_id);
            activeSections.set(details.section_id, Date.now());
            track('section_view', details);
          } else if (!activeSections.has(details.section_id)) {
            activeSections.set(details.section_id, Date.now());
          }
          return;
        }
        const startedAt = activeSections.get(details.section_id);
        if (startedAt) {
          const duration = Date.now() - startedAt;
          activeSections.delete(details.section_id);
          if (duration >= 2000) track('section_engaged', { ...details, metadata_json: { duration_ms: duration } });
        }
      });
    }, { threshold: [0, 0.15, 0.5], rootMargin: '-10% 0px -10% 0px' });
    sections.forEach((section) => observer.observe(section));
  };

  const bindInteractions = () => {
    document.addEventListener('click', (event) => {
      const target = event.target.closest('a, button, input[type="submit"]');
      if (!target) return;
      const label = compactText(target.textContent || target.value, 160).toLowerCase();
      const href = target.getAttribute('href') || '';
      if (
        target.hasAttribute('data-mm-home-course')
        || target.hasAttribute('data-mm-placement')
        || /jetzt|lernen|kaufen|warenkorb|kurs starten|checkout/.test(label)
        || href.includes('/checkout')
      ) trackCta(target);
    }, true);

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
      trackCta(form.querySelector('[type="submit"]') || form);
      track('add_to_cart', sectionDetails(form));
      const returnTo = form.querySelector('[name="return_to"]')?.value || '';
      if (returnTo.includes('/checkout')) track('checkout_redirect', sectionDetails(form));
    }, true);

    document.addEventListener('toggle', (event) => {
      if (event.target instanceof HTMLDetailsElement && event.target.open) {
        track('faq_open', {
          ...sectionDetails(event.target),
          metadata_json: { question: compactText(event.target.querySelector('summary')?.textContent, 200) },
        });
      }
    }, true);
  };

  const finishActiveSections = () => {
    activeSections.forEach((startedAt, sectionId) => {
      const duration = Date.now() - startedAt;
      if (duration < 2000) return;
      const section = trackedSections()
        .find((item) => item.id === `shopify-section-${sectionId}` || item.id.endsWith(`__${sectionId}`));
      track('section_engaged', { ...sectionDetails(section), metadata_json: { duration_ms: duration } });
    });
    activeSections.clear();
    publishVitals();
    publishPending();
  };

  const initialize = () => {
    if (initialized) return;
    initialized = true;
    track('page_view');
    observeSections();
    observePerformance();
    bindInteractions();
    window.addEventListener('pagehide', finishActiveSections);
    window.setTimeout(publishVitals, 15000);
  };

  let attempts = 0;
  const waitForPublisher = window.setInterval(() => {
    attempts += 1;
    if (publishPending()) {
      window.clearInterval(waitForPublisher);
      initialize();
    } else if (attempts >= 100) {
      window.clearInterval(waitForPublisher);
    }
  }, 100);
})();
